import { track, analyticsKeys } from '@mobi/account/Utils'

export type PrecommitmentEvent = {
  interaction_type: 'Remove Bet Limit' | 'Edit Bet Limit' | 'Need Assistance'
  limitAmount: string | undefined
  location: 'Bet Limits' | undefined
  depositFrequency: undefined
}

const defaultPrecommitmentValues: Omit<PrecommitmentEvent, 'interaction_type'> = {
  depositFrequency: undefined,
  limitAmount: undefined,
  location: undefined,
}

export const precommitmentTracker = (event: PrecommitmentEvent) =>
  track(analyticsKeys.accountManagement, event)

export const trackRemoveBetLimit = () =>
  precommitmentTracker({
    interaction_type: 'Remove Bet Limit',
    ...defaultPrecommitmentValues,
  })

export const trackEditBetLimit = (limitAmount: string) =>
  precommitmentTracker({
    interaction_type: 'Edit Bet Limit',
    ...defaultPrecommitmentValues,
    limitAmount,
  })

export const trackNeedAssistance = () =>
  precommitmentTracker({
    interaction_type: 'Need Assistance',
    ...defaultPrecommitmentValues,
    location: 'Bet Limits',
  })
